// POPOVER
//

var fn_popover_init = function () {
    $('[data-toggle="popover"]').popover()
};
